var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgWrench = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wrench_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.31 11.082 4.772-4.772a2.957 2.957 0 0 0 3.943-3.943l-.926.93a.985.985 0 1 1-1.394-1.395l.926-.926A2.958 2.958 0 0 0 9.69 4.92L4.918 9.69a2.957 2.957 0 0 0-3.943 3.943l.926-.926a.985.985 0 0 1 1.394 1.394l-.926.924a2.958 2.958 0 0 0 3.94-3.943Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wrench_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgWrench);
export default ForwardRef;